import clsx from 'clsx'
import { forwardRef, PropsWithChildren, useEffect, useLayoutEffect, useRef } from "react";
import { createPortal } from 'react-dom';

export const Modal = forwardRef<HTMLDivElement, PropsWithChildren<{ onClose: () => void }>>(
  (
    {
      children,
      onClose
    },
    ref
  ) => {
    const divRef = useRef<HTMLDivElement>(document.createElement('div'))

    useEffect(() => {
      divRef.current.className = 'prometheus-modal__container'
      document.body.appendChild(divRef.current)
      return () => {
        if (divRef.current && document.body.contains(divRef.current)) {
          document.body.removeChild(divRef.current);
        }
      }
    }, [])

    useEffect(() => {
      const close = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          onClose();
        }
      }
      document.addEventListener('keydown', close)
      return () => document.removeEventListener('keydown', close)
    }, [onClose])

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
      // Only close if clicking on the backdrop itself, not on modal content
      if (e.target === e.currentTarget) {
        onClose();
      }
    };

    return createPortal(
      <div
        ref={ref}
        className={clsx(
          'prometheus-modal'
        )}
        onClick={handleBackdropClick}
      >
        {children}
      </div>,
      divRef.current
    )
  }
)
